import LongLat from "@mapmycustomers/shared/types/base/LongLat";

import EditActionType from "@app/scene/map/components/TerritoriesMode/enums/EditActionType";
import { Paths } from "@app/scene/map/components/TerritoriesMode/types/EditBoundsCommand";
import {
  InsertVertexCommand,
  MoveBoundsCommand,
  RemoveVertexCommand,
  UpdateVertexCommand,
} from "@app/scene/map/components/TerritoriesMode/utils/command";
import { edit, redo, reset, undo, undoAll } from "@app/util/undo";
import EditorState from "@app/util/undo/EditorState";

type Action =
  | { at: number; coordinate: LongLat; pathIndex: number; type: EditActionType.ADD_VERTEX }
  | { at: number; coordinate: LongLat; pathIndex: number; type: EditActionType.EDIT_VERTEX }
  | { at: number; pathIndex: number; type: EditActionType.REMOVE_VERTEX }
  | { paths: Paths; type: EditActionType.RESET }
  | { paths: Paths; type: EditActionType.UPDATE_PATHS } // used when all paths are updated at once, like when dragging
  | { type: EditActionType.CANCEL }
  | { type: EditActionType.REDO }
  | { type: EditActionType.UNDO };

const editBoundsReducer = (state: EditorState<Paths>, action: Action): EditorState<Paths> => {
  switch (action.type) {
    case EditActionType.ADD_VERTEX: {
      return edit(state, new InsertVertexCommand(action.pathIndex, action.at, action.coordinate));
    }

    case EditActionType.EDIT_VERTEX: {
      return edit(state, new UpdateVertexCommand(action.pathIndex, action.at, action.coordinate));
    }

    case EditActionType.REMOVE_VERTEX: {
      return edit(state, new RemoveVertexCommand(action.pathIndex, action.at));
    }

    case EditActionType.UPDATE_PATHS: {
      return edit(state, new MoveBoundsCommand(action.paths));
    }

    case EditActionType.UNDO: {
      return undo(state);
    }

    case EditActionType.REDO: {
      return redo(state);
    }

    case EditActionType.CANCEL: {
      return undoAll(state);
    }

    case EditActionType.RESET:
      return reset(action.paths);
  }

  return state;
};

export default editBoundsReducer;
